import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HandleDeleteVeridasApp from './HandleDeleteVeridasApp';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * Component to handle the effect of clicking the browser's "Back" button. If the button is clicked,
 * a confirmation message is displayed. If the user confirms, all registered information—such as the uploaded INE/passport
 * and selfie—will be deleted. Otherwise, the data will be preserved and the user can continue with the process.
 *
 * @param model getInvitationById: Model that contains all the information of the invitation.
 */
const useBackNavigation = ({ getInvitationById , validationId }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [isRedirected, setIsRedirected] = useState(false);

    const { handleDelete, handleDeleteStorage, mainUrl } = HandleDeleteVeridasApp({ getInvitationById , validationId });

    // handleDelete and mainUrl are rebuilt on every render, they are reached through
    // the ref so the effect below can keep an empty dependency list.
    const handleBackRef = useRef(null);
    handleBackRef.current = () => {
        handleDelete?.();
        toast.warn(t("all_the_recorded_information_was_lost"));
        navigate(mainUrl);
        handleDeleteStorage();
        setIsRedirected(true);
    };

    useEffect(() => {
        const pushFakeEntry = () => {
            window.history.pushState(null, '', window.location.pathname);
        };

        pushFakeEntry();

        const handlePopState = (e) => {
            e.preventDefault();

            const confirmed = window.confirm(t("are_you_sure_you_want_to_leave_and_delete_the_data"));

            if (confirmed) {
                handleBackRef.current();
            } else {
                pushFakeEntry();
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
        // The fake entry is pushed once on mount, an unstable dependency list pushed
        // one more entry on every render and buried the real history of the flow.
    }, []);

    return { isRedirected }
};

export default useBackNavigation;
